import React, { useMemo } from 'react';
import { Activity } from 'lucide-react';

const TodaySession = ({ trades = [] }) => {
  const todayStats = useMemo(() => {
    const now = new Date();
    const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    const todayTrades = trades.filter((trade) => {
      const tradeDate = new Date(trade.trade_date || trade.closeTime);
      return !isNaN(tradeDate.getTime()) && tradeDate >= startOfDay;
    });

    const totalProfit = todayTrades.reduce((sum, t) => sum + (Number(t.profit) || 0), 0);
    const winners = todayTrades.filter(t => Number(t.profit) > 0).length;
    const winRate = todayTrades.length > 0 ? (winners / todayTrades.length) * 100 : 0;

    return {
      count: todayTrades.length,
      profit: totalProfit,
      winRate,
    };
  }, [trades]);

  return (
    <div className="bg-card text-card-foreground rounded-lg shadow-sm border border-border p-4 md:p-6">
      <div className="flex items-center gap-2 mb-4">
        <Activity className="w-4 h-4 text-primary" />
        <h3 className="text-sm font-semibold text-foreground">Today's Session</h3>
      </div>

      {todayStats.count === 0 ? (
        <p className="text-sm text-muted-foreground">No trades recorded today.</p>
      ) : (
        <div className="space-y-3">
          <div className="flex justify-between items-center">
            <span className="text-sm text-muted-foreground">Trades</span>
            <span className="text-sm font-semibold">{todayStats.count}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-sm text-muted-foreground">P&L</span>
            <span className={`text-sm font-semibold ${todayStats.profit >= 0 ? 'text-green-500' : 'text-red-500'}`}>
              {todayStats.profit >= 0 ? '+' : ''}{todayStats.profit.toFixed(2)}
            </span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-sm text-muted-foreground">Win Rate</span>
            <span className="text-sm font-semibold">{todayStats.winRate.toFixed(0)}%</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default TodaySession;
